/**
 * Протяжка ряда мышью.
 *
 * На главной ряды листает карусель, а список замен — обычная полоса
 * с прокруткой: на тачпаде она листается, мышью — нет. Добавляем
 * перетаскивание, чтобы поведение было одинаковым.
 */
export function initDragScroll() {
    const rows = document.querySelectorAll('.replace__list');
    if (!rows.length) return;

    rows.forEach(row => {
        let startX = 0;
        let startScroll = 0;
        let dragging = false;
        // Отличаем перетаскивание от клика: без порога нажатие на
        // «Выбрать» иногда считалось протяжкой и не срабатывало.
        let moved = false;

        // Браузер тянет картинку как файл, и ряд в это время стоит.
        // Своё перетаскивание начинается только после того, как
        // отключено родное.
        row.addEventListener('dragstart', (event) => event.preventDefault());

        row.addEventListener('mousedown', (event) => {
            if (event.button !== 0) return;
            dragging = true;
            moved = false;
            startX = event.pageX;
            startScroll = row.scrollLeft;
        });

        row.addEventListener('mousemove', (event) => {
            if (!dragging) return;
            const shift = event.pageX - startX;
            if (Math.abs(shift) > 3) {
                moved = true;
                row.classList.add('is-dragging');
            }
            row.scrollLeft = startScroll - shift;
        });

        const stop = () => {
            dragging = false;
            row.classList.remove('is-dragging');
        };

        row.addEventListener('mouseup', stop);
        row.addEventListener('mouseleave', stop);

        // Клик после протяжки гасим: иначе отпускание кнопки над
        // карточкой выбирало рецепт, которого человек не выбирал.
        row.addEventListener('click', (event) => {
            if (moved) {
                event.preventDefault();
                event.stopPropagation();
                moved = false;
            }
        }, true);
    });
}
